import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { LegalEntityQueryKey } from './queryKey';
export const useDeleteLegalEntity = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation((id) => api.base.delete(`/api/legalentity/${id}`).then(() => id), {
        onSuccess: (deletedId) => {
            queryClient.setQueryData([LegalEntityQueryKey.LegalEntities], old => old ? old.filter(e => e.id !== deletedId) : old);
        },
        onError: (apiError) => {
            handleHttpError(intl)(apiError);
        },
    });
    return { deleteLegalEntity: mutateAsync, isLoading };
};
